import { object, number, array } from '@gogame/schemas';

import {
  FRAUD_PROTECTION_COUNTRIES,
  FRAUD_PROTECTION_DEVICE_TYPE,
  FRAUD_PROTECTION_OS_VERSION,
  FRAUD_PROTECTION_OS_VERSION_MAX_VALUE,
  FRAUD_PROTECTION_OS_VERSION_OPERATOR,
  FRAUD_PROTECTION_OS_VERSION_VALUE,
} from './constants';

export const osVersionSchema = object({
  [FRAUD_PROTECTION_OS_VERSION_VALUE]: number(),
  [FRAUD_PROTECTION_OS_VERSION_MAX_VALUE]: number(),
  [FRAUD_PROTECTION_OS_VERSION_OPERATOR]: number(),
});

export const fraudProtectionSchema = object({
  [FRAUD_PROTECTION_COUNTRIES]: array(number()).required(
    'Countries is required'
  ),
  [FRAUD_PROTECTION_DEVICE_TYPE]: number(),
  [FRAUD_PROTECTION_OS_VERSION]: osVersionSchema,
});
